module.exports = __webpack_public_path__ + "static/media/sombra-lateral.bf19a00e.svg";